import { Helmet } from 'react-helmet-async';
import PrivilegeCard from './components/PrivilegeCard';
import PrivilegeList from './components/PrivilegeList';

const PrivilegePage = () => {
  return (
    <>
      <Helmet>
        <title>Privilege | Caltex StarCard</title>
      </Helmet>
      <PrivilegeCard />
      <PrivilegeList />
    </>
  );
};

export default PrivilegePage;
